@if (form) {
  <ng-container [formGroup]="form">
    <mat-radio-group [id]="id" [formControlName]="formControlName">
      @for (option of options; track optionTracker($index)) {
        <mat-radio-button
          [ngStyle]="{ 'padding-right': '20px' }"
          [value]="option.value"
          >
          {{ option.label }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </ng-container>
} @else {
  <mat-radio-group [id]="id" (change)="handleChange($event)" [value]="value">
    @for (option of options; track optionTracker($index)) {
      <mat-radio-button
        [ngStyle]="{ 'padding-right': '20px' }"
        [value]="option.value"
        >
        {{ option.label }}
      </mat-radio-button>
    }
  </mat-radio-group>
}
